<template>
    <!-- 添加/编辑团课课程 -->
    <el-dialog
        class="lessons-dialog"
        :visible.sync="visible"
        :title="title"
        left>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right"
            label-width="120px"
            label-suffix=":">
            <div>
                <el-form-item :label="$t('Course.name')" prop="name">
                    <el-input v-if="this.type === 'show'"
                        :disabled="true"
                        v-model="form.name"
                        :placeholder="$t('Fill.course_name')"></el-input>
                    <el-input
                        v-if="this.type !== 'show'"
                        v-model="form.name"
                        :placeholder="$t('Fill.course_name')"/>
                </el-form-item>
                <el-form-item :label="$t('Course.image')">
                    <file-upload v-if="form.images.length < 4"
                        ref="upload" @input="addImg(arguments)">
                        <div class="iconfont icon-fitness-jiahao lessons-image"></div>
                    </file-upload>
                    <!-- 图片显示 -->
                    <div
                        v-for="(item, index) in form.images"
                        :key="index"
                        class="add-lessons-pic"
                        :style="`background-image: url(${item});`">
                        <div
                            class="iconfont icon-fitness-jianshanchu-yuankuang add-lessons-delete"
                            @click="deleteImg(index)">
                        </div>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('Fill.course_time')" prop="duration">
                    <el-input v-if="this.type === 'show'"
                        :disabled="true"
                        class="lessons-minute"
                        type="number"
                        v-model.number="form.duration"
                        :placeholder="$t('Fill.course_fill_time')">
                    </el-input>
                    <el-input v-if="this.type !== 'show'"
                        class="lessons-minute"
                        type="number"
                        v-model.number="form.duration"
                        :placeholder="$t('Fill.course_fill_time')">
                    </el-input>&nbsp;&nbsp;{{ $t('Common.minute') }}
                </el-form-item>
                <el-form-item :label="$t('Fill.course_store')" prop="storeIds">
                    <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        @change="handleCheckAllStores">
                        {{ $t('Course.check_all') }}
                    </el-checkbox>
                    <div class="lessons-check-store">
                        <el-checkbox-group
                            v-model="form.storeIds"
                            @change="handleCheckStores">
                            <el-checkbox
                                v-for="item in stores"
                                :label="item.id"
                                :key="item.id">
                                {{ item.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('Course.appoint_coach')">
                    <el-checkbox
                        :indeterminate="isCoachIndeterminate"
                        v-model="checkAllCoaches"
                        @change="handleCheckAllCoaches"
                    >
                    {{ $t('Course.check_all') }}
                    </el-checkbox>
                    <div class="lessons-check-store">
                        <el-checkbox-group
                            v-model="form.coachIds"
                            @change="handleCheckCoaches"
                        >
                            <el-checkbox
                                v-for="item in coaches"
                                :label="item.id" :key="item.id">
                                {{ item.nickname }}{{ item.isResigned ? '(离职)' : '' }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item prop="charge" class="lessons-buy" :label="$t('Course.pay_anthor')">
                    <el-radio v-model="form.charge" label="1">{{ $t('Common.yes') }}</el-radio>
                    <el-radio v-model="form.charge" label="0">{{ $t('Common.no') }}</el-radio>
                </el-form-item>
                <el-form-item :label="$t('Course.introduction')">
                    <el-input
                        class="lessons-desc"
                        v-model="form.description"
                        type="textarea"
                        :placeholder="$t('Fill.course_introduction')">
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer" v-if="this.type !== 'show'">
            <el-button @click="visible = false">{{ $t('Common.close') }}</el-button>
            <el-button @click="confirm" type="primary">{{ $t('Common.save') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog, Radio, DatePicker, Tree } from 'element-ui';
import FileUpload from '@/components/base/FileUpload.vue';
import filterRole from '@/mixins/filterRole.js';

export default {
    name: 'add-team-lesson',
    components: {
        ElDialog: Dialog,
        ElRadio: Radio,
        ElTree: Tree,
        ElDatePicker: DatePicker,
        FileUpload,
    },
    mixins: [filterRole],
    data() {
        return {
            title: this.$t('Course.add_course'),
            id: null,
            type: '',
            form: {
                charge: '0',
                description: '',
                name: '',
                duration: null,
                images: [],
                storeIds: [],
                coachIds: [],
            },
            visible: false,
            rules: {
                name: { type: 'string', required: true, message: this.$t('Common.name_placeholder') },
                duration: { required: true, type: 'number', message: this.$t('Fill.course_fill_time') },
                storeIds: {
                    type: 'array',
                    required: true,
                    message: this.$t('Course.choose_store'),
                    trigger: 'change',
                },
                charge: { type: 'string', required: true, message: this.$t('Course.choose_pay_anthor') },
            },
            checkAll: false,
            stores: [],
            isIndeterminate: false,
            checkAllCoaches: false,
            coaches: [],
            isCoachIndeterminate: false,
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            // 清空数据
            this.form = {
                charge: '0',
                description: '',
                name: '',
                duration: null,
                images: [],
                storeIds: [],
                coachIds: [],
            };
            this.id = null;
            this.checkAll = false;
            this.isIndeterminate = false;
            this.checkAllCoaches = false;
            this.isCoachIndeterminate = false;
            // 清空form数据
            this.$refs.form.resetFields();
        },
        async open(type, id) {
            this.type = type;
            this.fetchCoach();
            await this.fetchStore();
            if (type === 'edit') {
                this.fetchData(id);
                this.id = id;
                this.title = this.$t('Course.edit');
            } else if (type === 'show') {
                this.fetchData(id);
                this.id = id;
                this.title = this.$t('Course.edit');
            } else {
                this.title = this.$t('Course.add_course');
            }
            this.visible = true;
        },
        addImg(args) {
            this.form.images.push(args[0]);
        },
        deleteImg(index) {
            this.form.images.splice(index, 1);
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        handleCheckAllStores(val) {
            this.form.storeIds = val ? this.stores.map(el => el.id) : [];
            this.isIndeterminate = false;
        },
        handleCheckStores(value) {
            const checkedCount = value.length;
            this.checkAll = checkedCount === this.stores.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
        },
        // 教练
        async fetchCoach() {
            this.coaches = await this.filterRole(10);
        },
        handleCheckAllCoaches(val) {
            this.form.coachIds = val ? this.coaches.map(el => el.id) : [];
            this.isCoachIndeterminate = false;
        },
        handleCheckCoaches(value) {
            const checkedCount = value.length;
            this.checkAllCoaches = checkedCount === this.coaches.length;
            this.isCoachIndeterminate = checkedCount > 0 && checkedCount < this.coaches.length;
        },
        fetchData(id) {
            API.get(`lesson/team/${id}`).then(res => {
                res.charge = res.charge ? '1' : '0';
                this.form = res;
                this.handleCheckStores(this.form.storeIds);
                this.handleCheckCoaches(this.form.coachIds);
            }).catch(() => {});
        },
        confirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                this.handlePost();
            });
        },
        handlePost() {
            const form = Object.assign({}, this.form);
            form.charge = Number(form.charge) !== 0;
            if (this.id) {
                API.put(`lesson/team/${this.id}`, form).then(() => {
                    $ele.$message.success(this.$t('Message.success'));
                    this.$emit('fetchData');
                    this.resetForm();
                    this.visible = false;
                });
            } else {
                API.post('lesson/team', form).then(() => {
                    $ele.$message.success(this.$t('Message.success'));
                    this.$emit('fetchData');
                    // 清空数据
                    this.resetForm();
                    this.visible = false;
                });
            }
        },
    },
};
</script>

<style lang="scss">
.lessons-dialog {
    .el-dialog {
        width: 540px;
        margin: 0 !important;
    }
}
.el-dialog--center .el-dialog__body {
    padding: 25px 65px 0 25px;
}
.lessons-image {
    width: 100px;
    height: 60px;
    border: 1px solid #e6e6e6;
    position: relative;
    margin-right: 10px;
    border-radius: 3px;

    &:hover {
         background: #05abef;
    }

    &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 50px;
        color: #f2f2f2;

        &:hover {
            color: #fff;
        }
    }
}
.lessons-minute {
    width: 200px;
}
textarea {
    width: 100%;
    height: 100px;
}
.lessons-check-store {
    margin-top: 15px;
    border: 1px solid #e6e6e6;
    padding: 10px;
    max-height: 90px;
    overflow-y: auto;
}
.lessons-desc {
    height: 120px;
}
.add-lessons-pic {
    width: 100px;
    height: 60px;
    background-size: cover;
    background-position: center;
    display: inline-block;
    margin-right: 10px;
    position: relative;

    &:last-child {
        margin-right: 0;
    }
}
.add-lessons-delete {
    position: absolute;
    right: -6px;
    top: -15px;
    color: red;
}
</style>
